export const dropoffPickup = [
    {value: "lso-dropbox", label: "Use LSO Dropbox"},
    {value: "regular-schedule", label: "Regular Scheduled Pickup (Pre-Arranged)"},
    {value: "schedule-pickup", label: "Schedule a Pickup"},
]